import type { DefLookup } from "../catalog";
import { computeSystemCableSpecs } from "../cable-spec";
import { resolveDesignProfile } from "../design-profiles";
import type { Issue, System } from "../types";

/** Coverage is part of the result, including when the graph has no other findings. */
export function runDesignProfileDiagnostics(system: System, defLookup: DefLookup, autoSizeTargetPct: number): Issue[] {
  const profile = resolveDesignProfile(system);
  if (profile.status === "unavailable") return [{
    code: "design-profile-unavailable", severity: "warning",
    title: { key: "diag.design-profile-unavailable.title" },
    message: { key: "diag.design-profile-unavailable.message", vars: { profile: profile.id } },
    fix: { key: "diag.design-profile-unavailable.fix" },
    cableIds: system.cables.map(cable => cable.id),
  }];
  const cableIds = [...computeSystemCableSpecs(system, defLookup, undefined, autoSizeTargetPct)]
    .filter(([, spec]) => spec.sizingVerificationRequired).map(([id]) => id);
  if (!cableIds.length) return [];
  return [{
    code: "design-profile-sizing-unverified", severity: "warning",
    title: { key: "diag.design-profile-sizing-unverified.title" },
    message: { key: "diag.design-profile-sizing-unverified.message", vars: { count: cableIds.length } },
    fix: { key: "diag.design-profile-sizing-unverified.fix" }, cableIds,
  }];
}
